module.exports = __webpack_public_path__ + "img/c00_buildingtechchainmail_Normal_ua.bd031ec2.webp";